<div>
  <div class="headerText">Survey Responses</div>
</div>

<div class="p-grid">
  <div class="p-col-12">
    <p-floatlabel variant="on">
      <input pInputText id="search-label" [(ngModel)]="searchTerm" autocomplete="off" />
      <label for="search-label"><i class="pi pi-search"></i> Search</label>
    </p-floatlabel>
  </div>
</div>

<p-table showGridlines stripedRows responsiveLayout="stack" #dt [columns]="cols"
  [value]="surveyHeaders | surveyHeaderFilter: searchTerm" [paginator]="true" [rows]="30">
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col) {
      <th [pSortableColumn]="col.field" [style.width]="col.width">
        {{col.header}}
        @if (col.header != '') {
        <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
          ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
        </p-sortIcon>
        }
      </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-surveyHeader let-columns="columns" let-rowIndex="rowIndex">
    <tr>
      <td><span class="p-column-title">{{columns[0].header}}</span>{{surveyHeader.tempCustomerName}}</td>
      <td><span class="p-column-title">{{columns[1].header}}</span>{{surveyHeader.tempPhoneNumber | phoneNumber}}</td>
      <td><span class="p-column-title">{{columns[2].header}}</span>{{surveyHeader.customer.address.street}}</td>
      <td><span class="p-column-title">{{columns[3].header}}</span>{{surveyHeader.customer.address.zip}}</td>
      <td><span class="p-column-title">{{columns[4].header}}</span>{{surveyHeader.dateSent | date}}</td>
      <td><span class="p-column-title">{{columns[5].header}}</span>{{surveyHeader.dateCompleted | date}}</td>
      <td><span class="p-column-title">{{columns[6].header}}</span>
        {{surveyHeader.surveyAnswers[0].yesNoResponse ? 'Yes' : (surveyHeader.surveyAnswers[0].yesNoResponse === false ?
        'No' : null)}}
      </td>
      <td>
        <p-button type="button" icon="pi pi-eye" severity="secondary" (click)="viewSurvey(surveyHeader)"
          class="table-button">
        </p-button>
        <p-button type="button" icon="pi pi-trash" (click)="deleteSurveyHeader(surveyHeader)" severity="danger"
          class="table-button">
        </p-button>
      </td>
    </tr>
  </ng-template>
</p-table>